import { ArrowRight, Sparkles } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";

export default function Hero() {
  const c = useSiteContent();
  return (
    <section id="top" className="hero-bg pt-32 pb-24 md:pt-40 md:pb-32 text-white relative overflow-hidden">
      <div className="absolute inset-0 deco-lines opacity-30 pointer-events-none" />
      <div className="container-pl relative">
        <div
          className="rise mb-12 md:mb-16"
          data-testid="hero-brand"
        >
          <div className="text-[0.72rem] sm:text-xs tracking-[0.32em] uppercase text-[var(--sand-soft)] font-display font-semibold">
            Aotearoa · New Zealand
          </div>
          <h1 className="font-display font-extrabold text-white leading-[0.95] mt-3 text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] hero-headline">
            Paraprofessionals
            <span className="block text-[#F6C988] mt-2">Learning Community</span>
          </h1>
          <div className="mt-5 w-24 h-[2px] bg-[var(--sand-soft)]/60" />
        </div>

        <div className="max-w-3xl">
          <div
            className="rise inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-[0.72rem] tracking-[0.22em] uppercase font-display font-semibold"
            data-testid="hero-badge"
          >
            <Sparkles size={14} className="text-[var(--sand-soft)]" />
            NZQA-Accredited · New for Term 4 · Aotearoa NZ
          </div>

          <h2
            className="rise rise-2 hero-headline mt-6"
            data-testid="hero-headline-secondary"
          >
            <span className="block font-sans font-light text-white/90 text-xl sm:text-2xl md:text-3xl leading-snug tracking-wide">
              The first credentialled programme for teacher aides supporting
            </span>
            <span className="block font-display font-extrabold text-[#F6C988] text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] mt-4">
              English Language Learners.
            </span>
          </h2>

          <p
            className="rise rise-3 mt-7 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed"
            data-testid="hero-subhead"
          >
            A six-workshop NZQA-accredited micro-credential built around oral language, reading
            and writing — grounded in current research and aligned to Aotearoa&apos;s national
            frameworks.
          </p>

          <div className="rise rise-4 mt-10 flex flex-wrap gap-4" data-testid="hero-actions">
            <a href="#register" className="btn btn-sand" data-testid="hero-register-btn">
              Enrol now <ArrowRight size={18} />
            </a>
            <a
              href="#micro-credential"
              className="btn btn-secondary !text-white !border-white/40 hover:!bg-white hover:!text-[var(--forest)]"
              data-testid="hero-learn-more-btn"
            >
              Explore the Programme
            </a>
          </div>

          <div className="rise rise-4 mt-12 grid grid-cols-3 gap-6 max-w-xl" data-testid="hero-stats">
            <Stat number={c.stat1_number} label={c.stat1_label} />
            <Stat number={c.stat2_number} label={c.stat2_label} />
            <Stat number={c.stat3_number} label={c.stat3_label} />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display font-bold text-2xl md:text-3xl text-[var(--sand-soft)]">
        {number}
      </div>
      <div className="text-xs md:text-sm text-white/75 mt-1 leading-snug">{label}</div>
    </div>
  );
}
